import { render, staticRenderFns } from "./confirmation-modal.vue?vue&type=template&id=ba76250e&"
import script from "./confirmation-modal.vue?vue&type=script&lang=ts&"
export * from "./confirmation-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports